import { render } from "./ViewQuestion.vue?vue&type=template&id=1524e1ac&ts=true"
import script from "./ViewQuestion.vue?vue&type=script&lang=ts"
export * from "./ViewQuestion.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__